<span class="rnpl-slogan rnpl-slogan--full ms-2">&ndash; {{ slogan.full }}</span>
<span class="rnpl-slogan rnpl-slogan--abbr ms-2">&ndash; {{ slogan.abbreviated }}</span>
